import { SvgIcon } from '@mui/material';
import React, { FC } from 'react';

interface EyeOpenIconProps { }

const EyeOpenIcon: FC<EyeOpenIconProps> = (props) => (
    <SvgIcon data-testid="EyeOpenIcon" {...props}>
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-labelledby="eyeIconTitle" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" color="#000"> <title id="eyeIconTitle">Visible (eye)</title> <path d="M22 12C22 12 19 18 12 18C5 18 2 12 2 12C2 12 5 6 12 6C19 6 22 12 22 12Z" /> <circle cx="12" cy="12" r="3" /> </svg>
    </SvgIcon>
);

export default EyeOpenIcon;
